import { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import { AppDispatch, RootState } from "../../../slices/store";
import { handleDeleteClientService } from "../service/clientService";
import { clientsGet } from "../../../slices/clients/clientManagementSlice";
import { getSingleUser } from "../../../slices/users/userManagementSlice";
import { TodosContext } from "../../../context";
import { SelectedUser } from "../../../slices/clients/types";
import useRequestSettings from "../../../hooks/useRequestClient";
import {
  BUTTONS,
  DELETE_MODAL_SUB_TITLE,
  DELETE_MODAL_TITLE,
  contentDetails,
} from "./constants";
import useUserParams from "../../../hooks/useSingleUserParams";
import UseAuthConfig from "../../../hooks/useAuthConfig";
import DeleteModal from "../../../components/organisms/DeleteModal/DeleteModal";
import DetailsSection from "../../../components/templates/DetailsSection/DetailsSection";
import Loader from "../../../components/atoms/Loader/Loader";
import Headline from "../../../components/organisms/Headline/Headline";
import { ContentDetail } from "../../../components/templates/DetailsSection/types";
import BreadCrumb from "../../../components/organisms/Breadcrumb/BreadCrumb";

const ClientDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const selectedUser = useSelector(
    (state: RootState) => state.userManagement.selectedUser
  );
  const [isConfirmationModalShow, setIsConfirmationModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { addAlert } = useContext(TodosContext);
  const [reqRequests] = useRequestSettings();
  const getSingleUserParams = useUserParams(2);
  const { protectedResources }: any = UseAuthConfig();

  const fetchSingleUser = useCallback(() => {
    if (selectedUser === undefined && getSingleUserParams) {
      dispatch(getSingleUser(getSingleUserParams));
    }
  }, []);

  useEffect(() => {
    fetchSingleUser();
  }, [fetchSingleUser]);

  const handleOpenModal = () => setIsConfirmationModalShow(true);
  const handleCloseModal = () => setIsConfirmationModalShow(false);

  const detailsValueGenerator = (item: ContentDetail) => {
    const { name } = item;
    if (!selectedUser || !name) return;

    const value = selectedUser[name as keyof SelectedUser];
    if (name === "firstName" && selectedUser.lastName) {
      return `${selectedUser.firstName} ${selectedUser.lastName}`;
    }
    return value;
  };

  const handleMainButtonClick = (buttonType: string) => {
    if (buttonType === "Back") {
      return navigate(-1);
    } else if (buttonType === "Delete") {
      handleOpenModal();
    }
  };

  const handleConfirm = () => {
    handleDeleteClientService(
      selectedUser,
      reqRequests,
      setIsLoading,
      dispatch,
      addAlert,
      true,
      navigate,
      clientsGet,
      protectedResources
    );
    handleCloseModal();
  };

  return (
    <Container fluid className="layout-bar">
      <BreadCrumb />

      <Headline name="Customer Details" subHeading="View and manage all your customers easily"/>

      {isLoading ? (
        <Loader />
      ) : (
        <DetailsSection
          BUTTONS={BUTTONS}
          DetailsValueGenerator={detailsValueGenerator}
          contentDetails={contentDetails}
          handleMainButtonClick={handleMainButtonClick}
          title={`${selectedUser?.firstName} ${selectedUser?.lastName}`}
        />
      )}
      <DeleteModal
        title={DELETE_MODAL_TITLE}
        subTitle={DELETE_MODAL_SUB_TITLE}
        show={isConfirmationModalShow}
        onClose={handleCloseModal}
        onConfirm={handleConfirm}
      />
    </Container>
  );
};

export default ClientDetails;
